import i18n from "../i18n";

export const menuItems = [
  {
    id: 1,
    label: i18n.t("menuitems.menu.text"),
    isTitle: true,
  },
  {
    id: 2,
    label: i18n.t("menuitems.dashboard.text"),
    icon: "ri-dashboard-line",
    link: "/",
  },
  {
    id: 7,
    roles: [1],
    label: i18n.t("menuitems.projects.text"),
    icon: "ri-file-list-line",
    link: "/projects",
  },
  {
    id: 8,
    roles: [3],
    label: i18n.t("menuitems.projects.text"),
    icon: "ri-file-list-line",
    link: "/my-essays",
  },
  {
    id: 3,
    roles: [1],
    label: i18n.t("menuitems.settings.text"),
    icon: "ri-settings-2-line",
    subItems: [
      {
        id: 4,
        roles: [1],
        label: i18n.t("menuitems.users.text"),
        icon: "ri-team-fill",
        link: "/users",
      },
      // {
      //   id: 5,
      //   roles: [1],
      //   label: i18n.t("menuitems.centers.text"),
      //   icon: "ri-team-fill",
      //   link: "/centers",
      // },
      // {
      //   id: 8,
      //   roles: [1],
      //   label: i18n.t("menuitems.courses.text"),
      //   icon: "ri-team-fill",
      //   link: "/courses",
      // },
      // {
      //     id: 6,
      //     roles: [1],
      //     label: i18n.t('menuitems.departments.text'),
      //     icon: 'ri-team-fill',
      //     link: '/departments'
      // }
    ],
  },
];
